import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject, debounceTime } from 'rxjs';
import { ResetPassword, SignUp } from 'src/app/model/request/auth';
import { BaseResponse } from 'src/app/model/response/base-response';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { LoginService } from '../login.service';

@Component({
  selector: 'app-resetpassword-form',
  templateUrl: './resetpassword-form.component.html',
  styleUrls: [ '../login.component.scss','./resetpassword-form.component.scss'],
  providers:[DatePipe]
})
export class ResetpasswordFormComponent {
back() {
throw new Error('Method not implemented.');
}
isCompleted: boolean=false;

// create strict typed angular form, preaty neat
formReset = new FormGroup({
  password: new FormControl<string>('', [
    Validators.required,
    Validators.minLength(8),
  ]),
  passwordConfirm: new FormControl<string>('', [
    Validators.required,
    Validators.minLength(8),
  ]),
});

formHaveErrors: boolean = false;
passwIcon: string = 'e-icons cursor-pointer spass';
errMsg: string = '';
rispSignUp!: BaseResponse;

//subjects for displaying errors while writing data on the form
private pwdConfirmSubject$: Subject<string> = new Subject<string>();
private pwdValidSubject$: Subject<string> = new Subject<string>();


//needed for form validation on signup method call
public pwdError: boolean = true;
public pattern: RegExp = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?.:,;&])[A-Za-zd$@$!%*?&].{8,32}');
public pwdNotValid: boolean = false;




constructor(
  private loginService: LoginService,
  private router: Router,
  private datePipe: DatePipe,
  private localStorageS:LocalStorageService,
) {
  this.passwIcon += ' e-eye';
}

ngOnInit(): void {

  //needed for displaying real time errors on form
  this.pwdConfirmSubject$.pipe(debounceTime(500)).subscribe({
    next: (value: string) => {
      if (value != this.formReset.value.password) {
        this.pwdError = false;
      } else {
        this.pwdError = true;
      }
    },
  });
  this.pwdValidSubject$.pipe(debounceTime(500)).subscribe({
    next: (value: string) => {
      let a = this.pattern.test(value);
      console.log(a);
      if (this.pattern.test(value)) {
        this.pwdNotValid = false;
      } else {
        this.pwdNotValid = true;
      }
    },
  });



}

pwdCheck(pwdC: string) {
  this.pwdConfirmSubject$.next(pwdC);
}

pwdValidation(pwd: string) {
  this.pwdValidSubject$.next(pwd);
}

route(){
  this.router.navigate(['/auth/login']);
}

resetPwd(){
  if(this.formReset.invalid){
    this.errMsg = 'Compila tutti i campi';
    this.formHaveErrors = true;
    console.error(
      'Errors in form validation, check the inserted data and try again'
    );
    return;
  }

  let resetData: ResetPassword={
    email: this.localStorageS.getMail(),
    otpCode: this.localStorageS.getOtp(),
    password: this.formReset.value.password || '',
  }

  if(resetData.email == '' ||
    resetData.otpCode =='' ||
    resetData.password==''){
      this.errMsg="Errore nell'esecuzione della procedura, torna alla schermata di login e riprova";
      this.formHaveErrors=true;
      console.error('Fields are void')
    }

  this.loginService.resetPwd(resetData).subscribe({
    next:(response:any)=>{
      this.isCompleted=true;
      this.localStorageS.removeMail();
      this.localStorageS.removeOtp();
    },
    error:(response:any)=>{
      this.errMsg=response;
      this.formHaveErrors=true;
      console.error(response);
    }
  })

}

showPassword() {
  const pwdI = document.getElementById('pwdInput');
  const pwdIc = document.getElementById('pwdInputConfirm');
  if (this.passwIcon.includes('-slash')) {
    this.passwIcon = this.passwIcon.replace('-slash', '');
    pwdI?.setAttribute('type', 'password');
    pwdIc?.setAttribute('type', 'password');
    console.log('removed slash');
  } else {
    this.passwIcon += '-slash';
    pwdI?.setAttribute('type', 'text');
    pwdIc?.setAttribute('type', 'text');
    console.log('added slash');
  }
}
}
